export default __webpack_public_path__ + "static/media/koike-photo.694f20da.jpg";